import PropTypes from 'prop-types';
var placement = ['bottom-end', 'bottom-start', 'bottom', 'leading-end', 'leading-start', 'leading', 'trailing-end', 'trailing-start', 'trailing', 'top-end', 'top-start', 'top'];
var paginationI18bPropTypes = {
  currentPage: PropTypes.string,
  goto: PropTypes.string,
  next: PropTypes.string,
  pageSizeInformation: PropTypes.string,
  paginationNavigation: PropTypes.string,
  previous: PropTypes.string,
  selectPageSize: PropTypes.string
};
var pageSizePropTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.number.isRequired
};
var propTypes = {
  currentPage: PropTypes.number,
  defaultCurrentPage: PropTypes.number,
  i18n: PropTypes.shape(paginationI18bPropTypes),
  hideLastPage: PropTypes.bool,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  pageSize: PropTypes.number,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.shape(pageSizePropTypes).isRequired),
  paginationNavigationSize: PropTypes.number,
  popoverPlacement: PropTypes.oneOf(placement),
  responsiveBreakpoint: PropTypes.string,
  totalItems: PropTypes.number.isRequired
};
export default propTypes;